import { render, staticRenderFns } from "./CatalogComponent.vue?vue&type=template&id=94d8d986&scoped=true"
import script from "./CatalogComponent.vue?vue&type=script&lang=js"
export * from "./CatalogComponent.vue?vue&type=script&lang=js"
import style0 from "./CatalogComponent.vue?vue&type=style&index=0&id=94d8d986&prod&lang=scss&scoped=true"
import style1 from "./CatalogComponent.vue?vue&type=style&index=1&id=94d8d986&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94d8d986",
  null
  
)

export default component.exports